import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { MainTableService } from '../table/main-table/main-table.service';
import { MobileManageOverlayComponent } from './mobile-manage-overlay.component';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs';
import { TMobileListSectionItem } from '@prlw/common/mobile-list-section/mobile-list-section.component';
import {
  MainTableColumn,
  MainTableColumnId,
} from '@prlw/core/monitor/types/main-table';

@Component({
  selector: 'prlw-mobile-manage-overlay',
  standalone: true,
  imports: [CommonModule, MobileManageOverlayComponent],
  templateUrl: './mobile-manage-overlay.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileManageOverlayContainer {
  @Output() eventClose = new EventEmitter();

  constructor(private readonly mainTableService: MainTableService) {}

  columns$ = this.mainTableService.columns$.pipe(
    map((columns) =>
      columns.map((column) => ({
        text: column.name,
        subText: null,
        icon: column.isStatic ? null : 'sandwich',
        favorite: false,
        checked: null,
        switchChecked: column.isStatic ? null : (column.isVisible ?? false),
        column,
        allowDragDrop: !column.isStatic,
      })),
    ),
  );

  handleMobileListSectionItemClick(
    item: TMobileListSectionItem & {
      column: MainTableColumn<MainTableColumnId>;
    },
  ): void {
    this.mainTableService.toggleColumnVisible(item.column.id);
  }

  handleUpdateItemsInArray(
    items: (TMobileListSectionItem & {
      column: MainTableColumn<MainTableColumnId>;
    })[],
  ) {
    this.mainTableService.updateColumns(items.map((item) => item.column));
  }
}
